module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_6-92554624293f811ee7d8c2b6386c3625.png";